import { Formik } from "formik";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Modal } from "rsuite";
import { ItemDataType } from "rsuite/esm/@types/common";
import { Button } from "..";
import { images } from "../../assets";
import { generateUUID } from "../../helpers/guid";
import { fileUrl } from "../../redux/base/url";
import { Price } from "../../redux/cars/types/carDetail";
import { getCarPriceList } from "../../redux/definitions";
import garageCart from "../../redux/garageCart";
import { GarageCartItem } from "../../redux/garageCart/type";
import { getLocalized } from "../../redux/localization";
import { ButtonType } from "../button";
import * as Yup from "yup";
import GarageDetailSpecCard from "./garagedetailspeccard";
import "./style.scss";
import CreateOfferPage from "../../pages/offer";
import CustomSelectPicker from "../../pages/offer/input";
import { AiOutlineArrowRight } from "react-icons/ai";

const GarageDetailCard = ({
  data,
  isDetail = false,
  setLoader,
}: {
  isDetail?: boolean;
  data?: GarageCartItem;
  setLoader: (data: boolean) => void;
}) => {
  const localize = useSelector(getLocalized);
  const dispatch = useDispatch();
  const [price, setPrices] = useState<Price[]>([]);
  const [showClone, setShowClone] = useState(false);
  const [kmLimit, setKmLimit] = useState<Price[]>([]);
  const [showOffer, setShowOffer] = useState(false);
  const validationSchema = Yup.object({
    Price: Yup.object().required("zorunlu"),
  });
  const dataRef = useRef<GarageCartItem>({
    ExtraServices: data?.ExtraServices ? data.ExtraServices : [],
    Count: data?.Count ? data.Count : 1,
    Car: data?.Car,
    Id: data?.Id,
    Price: data?.Price,
    Color: data?.Color,
    Insurance: data?.Insurance,
  });
  return (
    <div className="garage-detail-card">
      <div className="divider-div gdc-content ">
        {data?.Car?.CarImages ? (
          <div className="garageImgComp w-100">
            <img
              className="garage-img"
              src={fileUrl(data?.Car?.CarImages.FrontRightImage)}
              alt=""
              width={"275px"}
              height={"auto"}
            />
          </div>
        ) : (
          <div style={{ width: 167, height: 100 }} />
        )}
        <div className="divider-div gdc-car-info">
          <div style={{ marginBlockStart: 11 }}>
            <div className="divider-div">
              <span className="titleboldText">
                {data?.Car?.CarBrand} {data?.Car?.CarModel}
              </span>
              {!isDetail && (
                <img
                  className="gdc-trash"
                  alt=""
                  src={images.coloredtrash}
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    setLoader(true);
                    await dispatch(garageCart.actions.removeToGarage(data));
                    setLoader(false);
                  }}
                />
              )}
            </div>
            <p className="subtitleboldText ">
              {data?.Car?.CarVersion} {data?.Car?.CarPack}
            </p>
            <div style={{ marginBlockStart: 17 }}>
              <table>
                <tr>
                  <th className="gdc-table boldText">
                    {localize.getString("kmlimit")}
                  </th>
                  <th className="gdc-table boldText">
                    {localize.getString("period/month")}
                  </th>

                  <th className="gdc-table boldText"></th>
                </tr>
                <tr>
                  <td className="text">
                    {new Intl.NumberFormat("tr-TR", {
                      maximumSignificantDigits: 5,
                    }).format(
                      data?.Price?.KMLimitPerYear
                        ? data.Price.KMLimitPerYear
                        : 0
                    )}{" "}
                    TL
                  </td>
                  <td className="text">{data?.Price?.PeriodCount}</td>
                  <td className="text"></td>
                </tr>
              </table>
            </div>
            <div className="divider-div" style={{ marginBlockStart: 13 }}>
              <p className="subtitleboldText">
                {localize.getString("monthlyprice")}{" "}
                <span className="bigText">
                  {new Intl.NumberFormat("tr-TR", {
                    maximumSignificantDigits: 20,
                  }).format(
                    data?.Price?.PricePerMonth ? data?.Price.PricePerMonth : 0
                  )}{" "}
                  TL
                </span>
              </p>
              <span className="text" style={{ marginBlockStart: 12 }}>
                {data?.Count} {localize.getString("count")}{" "}
                {localize.getString("car")}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBlockStart: 5,
              }}
            >
              {!isDetail && (
                <>
                  <Button
                    title={localize.getString("edit")}
                    buttonType={ButtonType.garage}
                    style={{
                      width: 142,
                      height: 25,
                      marginBlockEnd: 3,
                      marginInlineEnd: 23,
                    }}
                    onClick={() => {
                      setShowOffer(true);
                    }}
                  />
                  <Button
                    title={localize.getString("clonecar")}
                    buttonType={ButtonType.garage}
                    style={{
                      width: 142,
                      height: 30,
                      marginBlockEnd: 3,
                    }}
                    onClick={() =>
                      dispatch(
                        getCarPriceList({
                          payload: {
                            onSuccess: (message, payload) => {
                              setPrices(payload);

                              setShowClone(true);
                            },
                            onError: (message) => {},
                          },
                          url:
                            "api/car/price/bycarid/" + dataRef.current.Car?.Id,
                        })
                      )
                    }
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal size={"xs"} open={showClone} onClose={() => setShowClone(false)}>
        <Modal.Header>
          <div className="header-font text-center w-100">
            Alternatif Plan Ekle
          </div>
        </Modal.Header>

        <Divider className="px-0 " />
        <div>
          <Formik
            initialValues={{
              Price: null,
            }}
            onSubmit={async (values: any) => {
              const cloneData = {
                ExtraServices: data?.ExtraServices ? data.ExtraServices : [],
                Count: data?.Count ? data.Count : 1,
                Car: data?.Car,
                Id: generateUUID(),
                Price: values?.Price,
                Color: data?.Color,
                Insurance: data?.Insurance,
              };
              await dispatch(garageCart.actions.addToGarage(cloneData));
              setShowClone(false);
            }}
            validationSchema={validationSchema}
          >
            {({ handleSubmit, setFieldValue, errors, touched }) => {
              return (
                <>
                  <div className="d-flex align-items-center flex-column w-100">
                    <div>
                      <CustomSelectPicker
                        title={""}
                        data={
                          price
                            ? price
                                .filter(
                                  (current, i, a) =>
                                    a.findIndex(
                                      (price) =>
                                        price.PeriodId === current.PeriodId
                                    ) === i
                                )
                                .sort((a, b) => a.PeriodCount - b.PeriodCount)
                            : []
                        }
                        searchable={false}
                        style={{ width: 200 }}
                        placement="bottomStart"
                        placeholder={localize.getString("period")}
                        labelKey="PeriodCount"
                        valueKey="PeriodId"
                        onSelect={(
                          value: string,
                          item: ItemDataType,
                          event
                        ) => {
                          const kmArray = price?.filter(
                            (x) => x.PeriodId === value
                          );
                          kmArray ? setKmLimit(kmArray) : setKmLimit([]);
                        }}
                      />
                    </div>
                    <div>
                      <CustomSelectPicker
                        title={""}
                        data={kmLimit.sort(
                          (a, b) => a.KMLimitPerYear - b.KMLimitPerYear
                        )}
                        searchable={false}
                        placement="bottomStart"
                        style={{ width: 200 }}
                        placeholder={localize.getString("kmlimit")}
                        labelKey="KMLimitPerYear"
                        valueKey="Id"
                        onSelect={(value: string, item: any, event) => {
                          setFieldValue("Price", item);
                        }}
                      />
                    </div>
                    <Button
                      title={localize.getString("addtogarage")}
                      buttonType={ButtonType.newColored}
                      icon={<AiOutlineArrowRight></AiOutlineArrowRight>}
                      style={{
                        width: 139,
                        height: 30,
                        fontWeight: 700,
                        fontSize: 20,
                        marginBlock: 10,
                        marginInlineEnd: 10,
                      }}
                      onClick={handleSubmit}
                    />
                  </div>
                </>
              );
            }}
          </Formik>
        </div>
      </Modal>
      <div className="gdc-carspecs">
        <GarageDetailSpecCard
          icon="gas-station"
          value={data?.Car?.CarSpecs.FuelType}
          title={localize.getString("fueltype")}
        />
        <GarageDetailSpecCard
          icon="gear-lever"
          value={data?.Car?.CarSpecs.GearType}
          title={localize.getString("geartype")}
        />
        <GarageDetailSpecCard
          icon="car"
          value="Sedan"
          title={localize.getString("bodytype")}
        />

        <GarageDetailSpecCard
          icon="fuel-burn"
          value={
            (data?.Car?.CarSpecs.ConsumptionMin &&
            data?.Car?.CarSpecs.ConsumptionMin > 0
              ? data?.Car?.CarSpecs.ConsumptionMin
              : "-") + " lt/100km"
          }
          title={localize.getString("consumption")}
        />
        <GarageDetailSpecCard
          icon="co2"
          value={
            (data?.Car?.CarSpecs.CarbonDioxideMin &&
            data?.Car?.CarSpecs.CarbonDioxideMin > 0
              ? data?.Car?.CarSpecs.CarbonDioxideMin
              : "-") + " g/km"
          }
          title={localize.getString("co2")}
        />
      </div>
      {data && data.Car && (
        <CreateOfferPage
          garageItem={data}
          car={data.Car}
          show={showOffer}
          onHide={() => setShowOffer(false)}
        />
      )}
    </div>
  );
};
export default GarageDetailCard;
